/*****************************
 * LEGO-TOOLTIP
 * v4.15
 * How to use
 * default              : v-lego-tooltip="tooltip message"
 * ellipsis             : v-lego-tooltip:ellipsis="tooltip message"
 * dynamic more action  : v-lego-tooltip="{ arg: 'ellipsis', value: 'Fatal', moreAction: 'clickToHide', position: 'top-left', timer: 5000, lines: 8, class:'dynamicClass", isShowHTML: flase  }"
 * type arg             : 'click' | 'ellipsis' | ''
 * type moreAction      : 'clickToHide' | ''
 * type position        : 'top' | 'left' | default : 'bottom-right'
 *
 *****************************/
import { nextTick } from 'vue';
import './styles.css';

const isObjKey = (obj, key) => obj ? Object.prototype.hasOwnProperty.call(obj, key) : false;

const isActiveEllipsis = (el) => {
  const elStyle = getComputedStyle(el);
  const ctx = document.createElement('canvas').getContext('2d');
  ctx.font = `${elStyle.fontSize} ${elStyle.fontFamily} `;
  const text = ctx.measureText(el.innerText);

  const lineHeight = text.fontBoundingBoxDescent + text.fontBoundingBoxAscent
  const line = Math.floor(parseFloat(elStyle.height) / lineHeight) || 1
  const elWidth = parseFloat(elStyle.width) * line;

  return text.width > elWidth;
};

const checkEllipsis = (el) => {
  if (el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight) return true;
  if (el.offsetWidth == el.scrollWidth && isActiveEllipsis(el)) return true;
  return false
}
const checkBindingObject = (binding) => {
  return binding.value && typeof binding.value == 'object'
}

const getValue = (binding = {}, key = '') => {
  return checkBindingObject(binding) ? isObjKey(binding.value, key) ? binding.value[key] : '' : ''
}

const getValueDefault = (binding = {}, key = '') => {
  return checkBindingObject(binding) ? isObjKey(binding.value, key) ? binding.value[key] : '' : binding[key] || ''
}

let hoverTimeout;
const tooltipInit = (el, binding) => {
  const $tooltip = document.createElement('div');
  const bindingArg = getValueDefault(binding, 'arg');
  const bindingMoreAction = getValue(binding, 'moreAction');
  const bindingPosition = getValue(binding, 'position')
  const bindingTimer = getValue(binding, 'timer')
  const bindingLines = getValue(binding, 'lines')
  const isShowHTML = getValue(binding, 'isShowHTML')
  const bindingClass = getValueDefault(binding, 'class');
  const cloneTooltip = $tooltip.cloneNode();
  el.$bindingClass = bindingClass
  el.$customNode = getValueDefault(binding, 'value');
  el.$argType = bindingArg;
  el.$position = bindingPosition.includes("-") ? bindingPosition.split("-") : [].concat(bindingPosition)
  el.$moreAction = bindingMoreAction
  el.$timer = bindingTimer || 300
  el.$lines = bindingLines || 0
  if (el.$argType == 'ellipsis') {
    cloneTooltip.style.whiteSpace = 'nowrap';
    cloneTooltip.style.display = 'inline-block';
    cloneTooltip.style.visibility = 'hidden';
    cloneTooltip.style.position = 'fixed';
  }
  el.$tooltip_enter = e => {
    $tooltip.setAttribute('class', `scp-tooltip  ${el.$bindingClass}`);
      if (isShowHTML) {
          $tooltip.innerHTML = el.$customNode
      } else {
          $tooltip.innerText = el.$customNode;
      }
    $tooltip.setAttribute('id', 'scpTooltip');

    const ellipsChecker = ['ellipsis'].includes(el.$argType) ? checkEllipsis(el) : false;
    if (ellipsChecker || el.$argType != 'ellipsis') {
      if (!$tooltip.contains(document.body)) document.body.appendChild($tooltip);
      tooltipMove(el, $tooltip, e, el.$argType);
      if (!$tooltip.hasAttribute('tooltip-timer')) {
        $tooltip.setAttribute('tooltip-timer', 'off')
        hoverTimeout = setTimeout(() => {
          $tooltip.setAttribute('tooltip-timer', 'on')
        }, el.$timer)
      }

      if (el.$lines) {
        $tooltip.setAttribute('scp-tooltip-lineclamp', 'true')
        $tooltip.style['-webkit-line-clamp'] = el.$lines
      }

      if (el.$moreAction === 'tooltipUnique') {
        $tooltip.setAttribute('tooltip-unique', '')
        handleUnique(el, true)
      }
    }
  };
  el.$tooltip_move = e => tooltipMove(el, $tooltip, e, el.$argType);
  el.$tooltip_leave = () =>  tooltipRemove(el, el.$argType)
  el.$tooltip_unique_leave = () => handleUnique(el, false)
  el.addEventListener('keypress',el.$tooltip_leave)
  el.addEventListener('mouseenter', el.$tooltip_enter);
  el.addEventListener('mousemove', el.$tooltip_move);
  el.addEventListener('wheel', el.$tooltip_leave, {
    passive: true
  });

  if (bindingMoreAction === 'clickToHide') {
    el.addEventListener('click',
      el.$tooltip_leave
    )
  }

  if (bindingMoreAction === 'tooltipUnique') {
    el.addEventListener('mouseleave', el.$tooltip_unique_leave);
  } else {
    el.addEventListener('mouseleave', el.$tooltip_leave);
  }
};
const tooltipMove = (parent, node, e, argType) => {
  const parentDimension = parent.getBoundingClientRect();
  const tooltipDimension = node.getBoundingClientRect();
  const windowW = document.body.clientWidth;
  const windowH = window.innerHeight;
  let tooltipPosY, tooltipPosX;

  // config position tooltip
  tooltipPosY = e.clientY + 24;
  tooltipPosX = e.clientX - 6;
  node.style.left = windowW <= tooltipPosX + tooltipDimension.width ? windowW - tooltipDimension.width - 10 + 'px' : tooltipPosX + 'px';
  node.style.top = windowH <= tooltipPosY + tooltipDimension.height + 10 ? parentDimension.top - tooltipDimension.height - 10 + 'px' : tooltipPosY + 'px';
  if (parent.$position.length) {
    for (const position of parent.$position) {
      switch (position) {
        case 'left':
          node.style.left = e.clientX + 10 - tooltipDimension.width + 'px'
          break
        case 'top':
          node.style.top = parentDimension.top - tooltipDimension.height - 10 + 'px'
          break
      }
    }
  }
};

const tooltipRemove = () => {
  const elem = document.querySelectorAll('#scpTooltip');
  if (!elem) return;

  if (elem.length) for (const node of elem) {
    if (node.hasAttribute('tooltip-timer')) {
      clearTimeout(hoverTimeout)
      node.removeAttribute('tooltip-timer')
    }
    node.style['visibility'] = ''
    node.parentNode.removeChild(node)
  }
};

const handleUnique = (el, hover) => {
  const elem = document.querySelectorAll('#scpTooltip');
  if (!elem) return;
  if (elem.length) for (const node of elem) {
    nextTick(() => {
      if (!node.hasAttribute('tooltip-unique')) {
        if (hover) return node.style['visibility'] = 'hidden'
        return node.style['visibility'] = 'visible'
      }
      if (!hover) node.parentNode.removeChild(node)
    })
  }
}

export default {
  name: 'lego-tooltip',
  mounted(el, binding) {
    if (binding.value === false || binding.value === null) return;
    tooltipInit(el, binding);
  },
  updated(el, binding, node) {
    if (binding.value === false || binding.value === null) return;
    const bindingArg = binding.value && typeof binding.value == 'object' ? isObjKey(binding.value, 'arg') ? binding.value.arg : '' : binding.arg || '';
    node.el.$customNode = binding.value && typeof binding.value == 'object' ? isObjKey(binding.value, 'value') ? binding.value.value : '' : binding.value;
    node.el.$argType = bindingArg.includes(':') ? bindingArg.split(':')[0] : bindingArg;
  },
  unmounted(el, binding) {
    if (binding.value === false || binding.value === null) return;
    el.removeEventListener('mouseenter', el.$tooltip_enter);
    el.removeEventListener('mousemove', el.$tooltip_move);
    el.removeEventListener('mouseleave', el.$tooltip_leave);
    el.removeEventListener('wheel', el.$tooltip_leave, {
      passive: true
    });
    tooltipRemove(el, el.$argType);

    if (el.$moreAction === 'hideToClick') el.removeEventListener('click', el.$tooltip_leave);
    if (el.$moreAction === 'tooltipUnique') el.removeEventListener('mouseleave', el.$tooltip_unique_leave);
  },
};